'use strict';

/* globals define, config, $, ajaxify */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/memoryGame/memory-game-print', [
	config.relative_path + '/plugins/nodebb-plugin-memory-game/static/vendor/printThis.js',
	'translator',
], function (printThis, translator) {
	var	GamePrint = {};

	GamePrint.init = function () {
		setActions();
		adjustSizeOfCards(3);
	};

	function setActions() {
		$('#print').on('click', function () {
			$('#cards').printThis();
		});

		$('#cardsInRow').on('change', function () {
			var cardsInRow = parseInt($(this).val(), 10);
			var cardsClass = 12 / cardsInRow;

			$('#cards > div').each(function () {
				$(this).removeClass();
				$(this).addClass('col-xs-' + cardsClass);
			});

			adjustSizeOfCards(cardsInRow);
		});
	}

	function adjustSizeOfCards(cardsInRow) {
		$('#cards .print-card > .card-body').each(function () {
			$(this).height(800 / cardsInRow);

			var img = $('img', $(this));
			var container = $('div', $(this));

			img.removeAttr('style');
			container.removeAttr('style');

			if (img.width() > img.height()) {
				img.css('width', '100%');
			} else {
				container.css('height', '100%');
				img.css('height', '100%');
			}
		});
	}

	return GamePrint;
});

